import React from 'react';
import { Container, BHANSALogo, AntEngineLogo } from './LoginPanel.style';
import LoginForm from '../loginForm/LoginForm';

const LoginPanel = () => (
  <Container>
    <LoginForm />
    <BHANSALogo href="https://www.bhansa.gov.ba/" target="_blank" />
    <AntEngineLogo href="https://www.antecna.com/" target="_blank" />
  </Container>
  );

export default LoginPanel;
